// Loads the Google AdSense script exactly once. The publisher client ID is a public
// identifier (safe to expose in browser code), supplied via REACT_APP_ADSENSE_CLIENT.
let loaderPromise;

export function loadAdSense(client) {
    if (!client) return Promise.reject(new Error("Missing AdSense client ID"));
    if (window.adsbygoogle) return Promise.resolve();
    if (loaderPromise) return loaderPromise;

    loaderPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(
            'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
        );
        if (existing) {
            existing.addEventListener("load", resolve, { once: true });
            existing.addEventListener("error", reject, { once: true });
            return;
        }
        const script = document.createElement("script");
        script.async = true;
        script.crossOrigin = "anonymous";
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error("AdSense script failed to load"));
        document.head.appendChild(script);
    });
    return loaderPromise;
}
